export enum eTypeStorage {
  Interno = 1,
  Externo = 2,
  Mixto = 3
}
